import { useTheme } from '@approvalmax/theme';
import { Grid } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { useSelector } from 'modules/react-redux';
import {
    AttachmentsSection,
    HeaderActions,
    NoteForApproversSection,
    RequesterInstructionSection,
} from 'pages/requestForm/components';
import { getContext } from 'pages/requestForm/selectors/pageSelectors';
import { FC } from 'react';
import bemFactory from 'react-bem-factory';
import { useMedia, useMount } from 'react-use';
import { displayActionsHeaderState, slotHeaderState } from 'shared/components';

import { DescriptionSection } from '../DescriptionSection/DescriptionSection';
import { MainSection } from '../MainSection/MainSection';
import { StandaloneFieldsSection } from '../StandaloneFieldsSection/StandaloneFieldsSection';
import { StandaloneRequestFormProps } from './StandaloneRequestForm.types';

const qa = bemFactory.qa('reqf-standalone-request-form');

export const StandaloneRequestForm: FC<StandaloneRequestFormProps> = (props) => {
    const { request } = props;

    const context = useSelector(getContext);
    const setSlotHeader = useSetAtom(slotHeaderState);
    const displayActionsHeader = useSetAtom(displayActionsHeaderState);

    const { theme } = useTheme();
    const mediumViewport = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);

    useMount(() => {
        setSlotHeader(<HeaderActions />);
        displayActionsHeader(false);
    });

    return (
        <Grid data-qa={qa()} gap={32}>
            <MainSection request={request} />

            <RequesterInstructionSection instructionText={context.requesterInstruction} />

            <NoteForApproversSection />

            <DescriptionSection request={request} />

            <StandaloneFieldsSection />

            <Grid gridTemplateColumns={mediumViewport ? '100%' : '50%'} gap={16}>
                <AttachmentsSection request={request} />
            </Grid>
        </Grid>
    );
};

StandaloneRequestForm.displayName = 'StandaloneRequestForm';
